export default function groupcolumnCellService() {
  return function generate(viewField, engineApi, engineGridApi) {
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);
    return {
      title: column.title,
      name: column.name,
      children: viewField?.properties?.length ? engineGridApi.mapPropertiesToColumns(viewField.properties) : [],
    };
  };
}
